export function stateTone(state: string): 'neutral' | 'good' | 'warn' | 'bad' | 'info' {
  if (state === 'LIVE' || state === 'supported') return 'good';
  if (state === 'FAILED' || state === 'DELETE_FAILED' || state === 'unsupported') return 'bad';
  if (state === 'NEEDS_INPUT' || state === 'conditionally_supported') return 'warn';
  if (['QUEUED', 'PROVISIONING', 'BUILDING', 'ANALYZING'].includes(state)) return 'info';
  return 'neutral';
}
